function getElementIndex(e: any) {
  const el = e && e.currentTarget
  const all = el ? [...el.parentElement.children] : []
  const index = el ? all.indexOf(el) : 0
  return {
    index: index,
    total: all.length,
    isFirst: index === 0,
    isLast: index === all.length - 1,
    el: el,
  }
}

export function defineTvListeners<T>(
  action: (payload: {
    type:
      | 'up'
      | 'down'
      | 'left'
      | 'right'
      | 'focus'
      | 'blur'
      | 'longPress'
      | 'click'
    index: number
    total: number
    isFirst: boolean
    isLast: boolean
    item: T
    el: Element
  }) => any,
  item?: T,
) {
  return {
    bind: (item: T) => defineTvListeners(action, item),
    up: (e: any) =>
      action({
        type: 'up',
        item: item!,
        ...getElementIndex(e),
      }),
    down: (e: any) =>
      action({
        type: 'down',
        item: item!,
        ...getElementIndex(e),
      }),
    left: (e: any) =>
      action({
        type: 'left',
        item: item!,
        ...getElementIndex(e),
      }),
    right: (e: any) =>
      action({
        type: 'right',
        item: item!,
        ...getElementIndex(e),
      }),
    onFocus: (e: any) =>
      action({
        type: 'focus',
        item: item!,
        ...getElementIndex(e),
      }),
    onBlur: (e: any) =>
      action({
        type: 'blur',
        item: item!,
        ...getElementIndex(e),
      }),
    longPress: (e: any) =>
      action({
        type: 'longPress',
        item: item!,
        ...getElementIndex(e),
      }),
    click: (e: any) =>
      action({
        type: 'click',
        item: item!,
        ...getElementIndex(e),
      }),
  }
}
